<template lang="pug">
    section#diferenciais
        include ../../../assets/svgs/vestibular/colors.svg
        div.wrapper
            h1
                |Além disso, o Centro Universitário UniFAEL tem pontos diferenciais que construíram sua
                |história até aqui e são a base para muitos anos de sucesso:
            ul
                li
                    include ../../../assets/svgs/vestibular/formados.svg
                    p
                        strong Mais de 150 mil alunos formados.
                li
                    include ../../../assets/svgs/vestibular/training.svg
                    p
                        strong Mais de 80 cursos de graduação a distância.
                li
                    include ../../../assets/svgs/vestibular/online-learning.svg
                    p
                        strong Mais de 190 cursos de pós-graduação a distância.
                li
                    include ../../../assets/svgs/vestibular/quality.svg
                    p
                        strong Notas altas na avaliação do MEC.
                        |Cursos avaliados com notas
                        |4 e 5, a nota  máxima do MEC.
                li
                    include ../../../assets/svgs/vestibular/piggy-bank.svg
                    p
                        strong Mensalidades que cabem no bolso.
                        //- |Todos os cursos de graduação por apenas 3xR$166,52¹ nesta campanha.
                li
                    include ../../../assets/svgs/vestibular/desk.svg
                    p
                        strong Mais de 700 unidades de apoio presencial em todo o Brasil.
                        |São polos distribuídos por todo o território nacional com a presença de Assistentes Acadêmicos UniFAEL.
                li
                    include ../../../assets/svgs/vestibular/students.svg
                    p
                        strong Aulas ao vivo e workshops.
                        |Momentos interativos com encontros presenciais nos polos UniFAEL.
                li
                    include ../../../assets/svgs/vestibular/online-learning-mobile.svg
                    p
                        strong Flexibilidade: estude onde e como quiser.
                        |Com acesso online aos conteúdos, você estuda de acordo com a sua disponibilidade de horário e local.


                li
                    include ../../../assets/svgs/vestibular/learn.svg
                    p
                        strong Livros didáticos impressos e/ou digitais inclusos.
                        |Com os livros didáticos você pode acompanhar os conteúdos além das aulas.

                li
                    include ../../../assets/svgs/vestibular/diploma.svg
                    p
                        strong Diploma igual ao do presencial.
                        |Os diplomas têm a mesma validade para o mercado de trabalho, sem a especificação da modalidade.
</template>

<script>
export default {
    name: "section-diferenciais"
}
</script>

<style lang="stylus" scoped src="./Diferenciais.styl"></style>
